import I18N from '@leverege/i18n';
import { Config } from '@leverege/plugin';
const {
  tf
} = I18N.ns('ui-attributes.condition.comparator.shared.ExistsComparator');
const TYPE = 'geoPoint.Exists';
const valueType = 'geoPoint';
function create() {
  return {
    type: TYPE
  };
}
export default {
  type: TYPE,
  TYPE,
  create,
  valueType,
  isPreferred(usage) {
    return false;
  },
  name: tf('name'),
  layout: () => {
    return Config.get('GeoPointExistsComparator', 'layout', {
      sort: 'zz'
    });
  }
};